if (!customElements.get('cart-notification')) {
  customElements.define('cart-notification', class extends HTMLElement {
    constructor() {
      super();
      this.notification = this.querySelector('#cart-notification');
      this.header = document.querySelector('sticky-header');
      this.querySelectorAll('[data-notice-close]').forEach(button => button.addEventListener('click', () => this.close()));
      this.notification.addEventListener('cancel', event => { event.preventDefault(); this.close(); });
      this.notification.addEventListener('keydown', event => {
        if (event.key !== 'Tab') return;
        const controls = [...this.notification.querySelectorAll('a[href], button:not([disabled])')].filter(element => element.getClientRects().length > 0);
        const first = controls[0];
        const last = controls[controls.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      });
      this.notification.addEventListener('close', () => {
        this.notification.classList.remove('active');
        document.body.classList.remove('ae-cart-notification-open');
        if (this.activeElement?.isConnected) this.activeElement.focus({ preventScroll: true });
      });
      this.notification.addEventListener('click', event => {
        if (event.target !== this.notification) return;
        const rect = this.notification.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.close();
      });
    }

    disconnectedCallback() {
      this.close();
    }

    open() {
      if (!this.notification.open) this.notification.showModal();
      this.notification.classList.add('active');
      document.body.classList.add('ae-cart-notification-open');
    }

    close() {
      if (this.notification.open) this.notification.close();
      this.notification.classList.remove('active');
      document.body.classList.remove('ae-cart-notification-open');
    }

    renderContents(parsedState) {
      this.cartItemKey = parsedState.key || parsedState.items?.[0]?.key;
      this.getSectionsToRender().forEach(section => {
        document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      });
      if (this.header) this.header.reveal();
      this.open();
    }

    getSectionsToRender() {
      return [
        { id: 'cart-notification-product', selector: `[id="cart-notification-product-${this.cartItemKey}"]` },
        { id: 'cart-notification-button' },
        { id: 'cart-notification-summary' },
        { id: 'cart-icon-bubble' }
      ];
    }

    getSectionInnerHTML(html, selector = '.shopify-section') {
      const section = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
      if (!section) throw new Error('Cart confirmation section unavailable');
      return section.innerHTML;
    }

    setActiveElement(element) {
      this.activeElement = element;
    }
  });
}
